import { inject, Injectable } from '@angular/core';
import { DeviceStoreActions, LocationsRouterStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { isNonEmptyString } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DeviceResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(LocationsRouterStoreSelectors.selectLocationId).pipe(
      filter((id): id is string => isNonEmptyString(id)),
      tap((locationId) => {
        this.store.dispatch(
          DeviceStoreActions.DeviceResolverActions.devicesRequested({
            categoryId: locationId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
